<template>
    <div class="col-sm-4">
        <div class="card">
            <div class="card-header">
                <h1 class="card-title">Test</h1>
            </div>
            <div class="card-body">
                bus:
                <pre>{{ bus }}</pre>
            </div>
        </div>
    </div>
</template>
<script>
    import Crudable from "../crudables/Crudable";

    export default {
        name: "CruTable",
        props: [
            'model'
        ],
        data()
        {
            return {
                bus: {},
            }
        },
        mounted()
        {
            let Model = null;
            if(typeof this.model === 'string'){
                Model = new Crudable(this.model);
            } else if(typeof this.model.$http === 'function'){
                Model = this.model;
            }
            if(Model){
                Model.where('status', -1)
                    .get()
                    .then(bus => {
                        this.bus = bus;
                        console.log(bus);
                    })
            }

        }
    }
</script>

<style scoped>

</style>